import { defineCustomElement } from 'vue'
import SecretForm from './SecretForm.ce.vue'
import rawVueCoreCss from 'virtual:vue-core-css-stripped'
import '@aj-fe/aj-vue-core/index.css'
import { captureUtmFromUrl } from './utils'

// 광고 유입 URL 의 utm_* 를 sessionStorage 에 자동 캡처 (이후 폼 제출 body 로 전달)
captureUtmFromUrl()

const vueCoreCss = rawVueCoreCss.replace(/(^|[^\w-]):root(?=\s*[{,])/g, '$1:host,:root')

const sfc = SecretForm as unknown as { styles?: string[] }
sfc.styles ??= []
sfc.styles.unshift(vueCoreCss)

export const AjdSecretForm = defineCustomElement(SecretForm)

export function register(tagName = 'ajd-secret-form'): void {
  if (!customElements.get(tagName)) {
    customElements.define(tagName, AjdSecretForm)
  }
}

register()

export type { CategoryItem, CategoryType, LoginInfo, SecretFormOptions } from './types'
